var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8109 1.10745C33.382 1.08941 9.66998 1.11977 4.18934 1.10745C2.4839 1.10745 1.1001 2.44901 1.1001 4.10121V39.9088C1.1001 41.5615 2.4839 42.9017 4.18934 42.9017H39.8109C41.5172 42.9017 42.9001 41.5615 42.9001 39.9084V4.10121C42.9001 2.44901 41.5172 1.10745 39.8109 1.10745ZM13.8033 36.0839H7.54786V17.2678H13.8029V27.9246C13.8055 29.8724 13.802 34.1079 13.8033 36.0839ZM10.6767 14.6995C8.56954 14.7219 7.17474 13.2686 7.17914 11.4488C7.17298 7.14249 14.1971 7.09409 14.2152 11.4492C14.2152 13.2545 12.8573 14.6995 10.6767 14.6995ZM36.3577 36.0839H30.1036V26.0189C30.1036 23.4894 29.1976 21.7641 26.9351 21.7641C24.6124 21.8451 23.4583 23.6469 23.5199 25.5776V36.0844L17.2653 36.0848C17.2653 36.0848 17.3475 19.0339 17.2657 17.2691H23.5203L23.4785 19.9971C24.3017 18.7127 25.7837 16.8273 29.1576 16.8273C33.2725 16.8273 36.3582 19.5166 36.3582 25.296V36.0839H36.3577Z",
    fill: "#EB2019"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.7a943c4198ca63539e82a3a5e061a4ad.svg";
export { ForwardRef as ReactComponent };